/***
 * PROJECT-SMS.WIDGET
 * Edit options for the SMS
 */

import { connect } from "react-redux"
import { WithTranslation, withTranslation } from "react-i18next"
import { ProjectState } from "@/redux/project.types"
import { store } from "@/index"
import TextInput from "@/components/text-input"
import ConfirmButtons from "@/components/confirm-buttons"
import ProjectStepErrorsWidget from "./project-step-errors.widget"
import { projectEditSmsOptions } from "@/redux/project.actions"

interface StateProps extends WithTranslation {
  project: ProjectState
}

interface OwnProps {
  onNext?: Function
  onEdit: Function
}

type Props = StateProps & OwnProps

function ProjectSmsWidget(props: Props) {
  const { t } = props

  function edit() {
    props.onEdit()
  }

  function editSmsOption(key: string, value: any) {
    store.dispatch(projectEditSmsOptions(key, value))
  }

  function next(isVisited, isConfirmed) {
    if (props.onNext) {
      props.onNext(isVisited, isConfirmed)
    }
  }

  return (
    <div style={{ padding: "10px 32px" }}>
      <div className="flex">
        <TextInput
          id="sms-sender"
          title={t("project_invitation_sms_sender")}
          value={props.project.active.smsOptions.sender}
          onBlur={edit}
          onChange={(e) => editSmsOption("sender", e.value)}
          isFullWidth
        />
        <div className="width-20" />
        <TextInput
          id="sms-country-code"
          title={t("project_invitation_sms_country_code")}
          value={props.project.active.smsOptions.countryCode}
          onBlur={edit}
          onChange={(e) => editSmsOption("countryCode", e.value)}
          isFullWidth
        />
        <div className="width-100" />
      </div>

      <TextInput
        id="sms-content"
        title={t("project_invitation_sms_content")}
        value={props.project.active.smsOptions.content}
        onBlur={edit}
        onChange={(e) => editSmsOption("content", e.value)}
        isFullWidth
      />

      <ProjectStepErrorsWidget alert={props.project.active.alerts.sms} step="sms" />

      {props.onNext && (
        <ConfirmButtons
          isLocked={props.project.active.alerts.sms.errors.length > 0}
          onCancel={() => next(false, false)}
          onConfirm={() => next(true, true)}
          onConfirmLater={() => next(true, false)}
        />
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  project: state.project
})

export default connect(mapStateToProps)(withTranslation()(ProjectSmsWidget))
